import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import MenuItem from "@material-ui/core/MenuItem";
import RefreshIcon from "@material-ui/icons/Refresh";

import { i18n } from "../../translate/i18n";

const PRESETS = [
	{ key: "yesterday", labelKey: "dashboard.filters.presets.yesterday" },
	{ key: "last7Days", labelKey: "dashboard.filters.presets.last7Days" },
	{ key: "currentMonth", labelKey: "dashboard.filters.presets.currentMonth" },
	{ key: "lastMonth", labelKey: "dashboard.filters.presets.lastMonth" },
];

const useStyles = makeStyles(theme => ({
	root: {
		marginBottom: theme.spacing(3),
	},
	presets: {
		marginBottom: theme.spacing(2),
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(1),
	},
	actions: {
		display: "flex",
		alignItems: "flex-end",
		height: "100%",
	},
}));

const DateRangeFilter = ({
	dateFrom,
	dateTo,
	agentId,
	agents,
	activePreset,
	onDateFromChange,
	onDateToChange,
	onAgentChange,
	onPreset,
	onRefresh,
}) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<Typography variant="h5" color="primary" gutterBottom>
				{i18n.t("dashboard.title")}
			</Typography>

			<div className={classes.presets}>
				<ButtonGroup size="small" variant="outlined" color="primary">
					{PRESETS.map(preset => (
						<Button
							key={preset.key}
							variant={
								activePreset === preset.key ? "contained" : "outlined"
							}
							onClick={() => onPreset(preset.key)}
						>
							{i18n.t(preset.labelKey)}
						</Button>
					))}
				</ButtonGroup>
			</div>

			<Grid container spacing={2} alignItems="flex-end">
				<Grid item xs={12} sm={6} md={2}>
					<TextField
						fullWidth
						label={i18n.t("dashboard.filters.dateFrom")}
						type="date"
						value={dateFrom}
						onChange={e => onDateFromChange(e.target.value)}
						InputLabelProps={{ shrink: true }}
						variant="outlined"
						size="small"
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={2}>
					<TextField
						fullWidth
						label={i18n.t("dashboard.filters.dateTo")}
						type="date"
						value={dateTo}
						onChange={e => onDateToChange(e.target.value)}
						InputLabelProps={{ shrink: true }}
						variant="outlined"
						size="small"
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<TextField
						fullWidth
						select
						label={i18n.t("dashboard.filters.agent")}
						value={agentId}
						onChange={e => onAgentChange(e.target.value)}
						variant="outlined"
						size="small"
					>
						<MenuItem value="">
							{i18n.t("dashboard.filters.allAgents")}
						</MenuItem>
						{(agents || []).map(agent => (
							<MenuItem key={agent.id} value={String(agent.id)}>
								{agent.name}
							</MenuItem>
						))}
					</TextField>
				</Grid>
				<Grid item xs={12} sm={6} md={2}>
					<div className={classes.actions}>
						<Button
							variant="outlined"
							color="primary"
							startIcon={<RefreshIcon />}
							onClick={onRefresh}
						>
							{i18n.t("dashboard.filters.refresh")}
						</Button>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default DateRangeFilter;
